import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const CountryPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Country}
        fetchRecordsUrl={AdminReqUrls.admin__country__mainPage_fetch_recordList}
    />)
});
export default CountryPage;
